import React, { useState } from 'react';
import { Form, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useGetContacts } from 'api/contacts/use-get-contacts.ts';
import type { IContactFormSelectProps } from './types';

export const ContactFormSelect: React.FC<IContactFormSelectProps> = (props) => {
  const {
    clientId,
    name,
    rules,
    handleContactChange,
    placeholder,
    label,
    className,
    disabled = false,
    allowClear = false,
  } = props;
  const [contactSearch, setContactSearch] = useState('');

  const { data: contacts, isFetching } = useGetContacts({
    limit: 20,
    search: contactSearch,
    clientId,
  });

  const handleContactSearch = debounce((value: string) => setContactSearch(value), 400);

  return (
    <Form.Item label={label} name={name} rules={rules} className={className}>
      <Select
        placeholder={placeholder}
        loading={isFetching}
        filterOption={false}
        notFoundContent={null}
        disabled={!clientId || disabled}
        options={(contacts?.data ?? []).map((contactItem) => ({
          value: contactItem.id,
          label: contactItem.name,
        }))}
        allowClear={allowClear}
        showSearch
        labelInValue
        onChange={handleContactChange}
        onSearch={handleContactSearch}
      />
    </Form.Item>
  );
};
